import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { Tabs } from "antd";
import ReportSuppliers from "./ReportSuppliers";
import ReportMaster from "./ReportMaster";
import ReportDm from "./ReportDm";
import ReportPm from "./ReportPm";
import { getReports } from "../../../utils/utilities";
import { useTranslation } from "react-i18next";

const Report = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const reports = getReports(userInfo);
  const mappingKeyReports = {
    reportDM: <ReportDm />,
    reportPM: <ReportPm />,
    reportSuppliers: <ReportSuppliers />,
    reportMaster: <ReportMaster />,
  };
  return (
    <Tabs
      className="PFtabs"
      defaultActiveKey={0}
      items={reports.map((r, i) => ({
        label: t(`report.tabs.${r.name}`),
        key: i,
        children: mappingKeyReports[r.component],
      }))}
    />
  );
};

export default Report;
